import {
  Home,
  Logout,
  NotFound,
  UserHome,
  Courses,
  Quiz,
  IssueList,
  IssueDetail,
  LiveCourses,
  LiveCourseDetail,
  PayPage,
  AlipayRedirect,
  PaySuccess,
  WxCode,
  UserOrders,
  UserCourses,
  UserCourseDetail,
  Answer,
  MyHomework
} from '../views'
import * as CourseDetail from '@ca/views/courseDetail/index.js'
import * as QuizDetail from '@ca/views/quizDetail/main'
// import * as Answer from '@ca/views/answer/main'
import * as Live from '@ca/views/live/index.js'

export default [
  // 主容器，会重定向到home
  {
    name: 'index',
    path: '/',
    meta: {
      title: 'Course System'
    },
    redirect: { name: 'live' }
  },
  // 主页
  {
    name: 'home',
    path: '/home',
    meta: {
      title: 'Course System'
    },
    component: Home
  },
  // 知识点课程列表页面
  {
    name: 'courses',
    path: '/courses',
    component: Courses,
    meta: {
      title: 'Knowledge debris | Course System'
    }
  },
  // 知识点课程详情页面
  {
    path: '/courses/:chapter/:section/:origin',
    component: CourseDetail.CourseDetail,
    children: [
      // 知识点课程视频页面
      {
        name: 'course-video',
        path: '',
        meta: { requiresAuth: true, title: 'Course System' },
        component: CourseDetail.CourseVideo
      },
      // 知识点课程题目页面
      {
        name: 'course-practice',
        path: 'practice',
        meta: { requiresAuth: true, title: 'Course System' },
        component: CourseDetail.CoursePractice
      }]
  },
  // 刷题列表页面
  {
    name: 'quiz',
    path: '/quiz',
    component: Quiz,
    meta: {
      title: 'Question Cracking | Course System'
    }
  },
  // 刷题详情页面
  {
    path: '/quizs/:chapter/:section/:origin',
    component: QuizDetail.QuizDetail,
    children: [
      {
        name: 'quiz-detail',
        path: '',
        meta: { requiresAuth: true, title: 'Course System' },
        component: QuizDetail.QuizPractice
      }
    ]
  },
  // 直播课程列表页面
  {
    name: 'live',
    path: '/live',
    component: LiveCourses,
    meta: {
      title: 'nav.CourseCenter'
    }
  },
  // 直播课程详情页面
  {
    name: 'liveCourseDetail',
    path: '/live/:origin',
    component: LiveCourseDetail,
    meta: {
      title: 'nav.CourseDetail'
    }
  },
  // 直播间页面
  {
    path: '/live/:liveId/:subId/',
    component: Live.LiveRoom,
    children: [
      // 直播页面
      {
        name: 'live-broadcast',
        path: 'live',
        meta: { requiresAuth: false, title: 'Live | Course System' },
        component: Live.LiveVideo
      },
      // 回放页面
      {
        name: 'live-replay',
        path: 'replay',
        meta: { requiresAuth: false, title: 'Replay | Course System' },
        component: Live.ReplayVideo
      }]
  },
  // 错题本列表页面
  {
    name: 'issueList',
    path: '/question-collection',
    component: IssueList,
    meta: {
      title: 'Mistake collection | Course System',
      requiresAuth: true
    }
  },
  // 错题本详情页面
  {
    name: 'questionDetail',
    path: '/question-detail/:origin/:index',
    meta: {
      title: 'Course System',
      requiresAuth: true
    },
    component: IssueDetail
  },
  // 个人信息页面
  {
    name: 'profile',
    path: '/profile',
    component: UserHome,
    meta: {
      title: 'nav.Account',
      requiresAuth: true
    }
  },
  // 用户课程列表页面
  {
    name: 'userCourses',
    path: '/user/courses',
    component: UserCourses,
    meta: {
      title: 'My Courses | Course System',
      requiresAuth: true
    }
  },
  // 用户课程详情页面
  {
    name: 'userCourseDetail',
    path: '/user/course_detail/:goods_id',
    component: UserCourseDetail,
    meta: {
      title: 'My Courses | Course System',
      requiresAuth: true
    }
  },
  // 用户订单页面
  {
    name: 'userOrders',
    path: '/user/orders',
    component: UserOrders,
    meta: {
      title: 'My Orders | Course System',
      requiresAuth: true
    }
  },
  // 登出页面
  {
    name: 'logout',
    path: '/logout',
    component: Logout,
    meta: {
      title: 'Log out | Course System'
    }
  },
  // 支付详情（选择支付方式）页面
  {
    name: 'payPage',
    path: '/charge/pay/:order_no',
    meta: {
      title: 'Checkout | Course System',
      requiresAuth: true
    },
    component: PayPage
  },
  // 重定向至阿里前的跳转页面
  {
    path: '/charge/alipay_redirect/:channel/:order_no',
    name: 'alipayRedirect',
    meta: {
      title: 'Pay | Course System',
      requiresAuth: true
    },
    component: AlipayRedirect
  },
  // 重定向至微信前的跳转页面
  {
    path: '/charge/wxcode',
    name: 'wxCode',
    meta: {
      title: 'WX pay | Course System',
      requiresAuth: true
    },
    component: WxCode
  },
  // 支付成功页面
  {
    name: 'checkoutSuccess',
    path: '/charge/order_pay_success',
    component: PaySuccess,
    meta: {
      title: 'Purchase Done | Course System',
      requiresAuth: true
    }
  },
  // 作业答题页面
  {
    name: 'answer',
    path: '/answer/:exam_id/:class_id/:subclass_id',
    component: Answer,
    meta: {
      requiresAuth: true,
      title: 'nav.Homework',
      isLoginReturn: true
    }
  },
  // 我的作业页面
  {
    name: 'myHomework',
    path: '/my-homework',
    component: MyHomework,
    meta: {
      requiresAuth: true,
      title: 'nav.MyCourses'
    }
  },
  // 404页面
  {
    path: '*',
    name: 'notFound',
    meta: { title: 'Not Found | NotFound' },
    component: NotFound
  }
]
